import { render, staticRenderFns } from "./Paging.vue?vue&type=template&id=18b37d18&scoped=true&"
import script from "./Paging.vue?vue&type=script&lang=ts&"
export * from "./Paging.vue?vue&type=script&lang=ts&"
import style0 from "./Paging.vue?vue&type=style&index=0&id=18b37d18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b37d18",
  null
  
)

export default component.exports